import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter,
  DialogHeader, DialogTitle, DialogTrigger,
} from '../ui/dialog';

export const ChildFormDialog = ({ open, onOpenChange, form, setForm, onSubmit, editing }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogTrigger asChild>
      <Button variant="outline" size="sm" data-testid="add-child-btn">
        <Plus className="mr-1 h-4 w-4" />
        Add Child
      </Button>
    </DialogTrigger>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle className="font-heading">{editing ? 'Edit Child' : 'Register Child'}</DialogTitle>
        <DialogDescription>Add a child to the sponsorship program</DialogDescription>
      </DialogHeader>
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label>Child Name *</Label>
          <Input
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            placeholder="Full name"
            required
            data-testid="child-name"
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Grade/Class</Label>
            <Input
              value={form.grade}
              onChange={(e) => setForm({ ...form, grade: e.target.value })}
              placeholder="e.g., P3, S2"
            />
          </div>
          <div className="space-y-2">
            <Label>Date of Birth</Label>
            <Input
              type="date"
              value={form.date_of_birth}
              onChange={(e) => setForm({ ...form, date_of_birth: e.target.value })}
            />
          </div>
        </div>
        <div className="space-y-2">
          <Label>School</Label>
          <Input
            value={form.school}
            onChange={(e) => setForm({ ...form, school: e.target.value })}
            placeholder="School name"
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Sponsor Name</Label>
            <Input
              value={form.sponsor_name}
              onChange={(e) => setForm({ ...form, sponsor_name: e.target.value })}
              placeholder="Sponsor's name"
            />
          </div>
          <div className="space-y-2">
            <Label>Initial Balance (UGX)</Label>
            <Input
              type="number"
              value={form.account_balance}
              onChange={(e) => setForm({ ...form, account_balance: parseFloat(e.target.value) || 0 })}
              placeholder="0"
            />
          </div>
        </div>
        <div className="space-y-2">
          <Label>Notes</Label>
          <Textarea
            value={form.notes}
            onChange={(e) => setForm({ ...form, notes: e.target.value })}
            placeholder="Any additional notes"
          />
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button type="submit" data-testid="child-submit-btn">{editing ? 'Update' : 'Register'}</Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);
